import React from "react";
import { Link } from "react-router-dom";
import Counter from "../components/Counter";

const team = [
  {
    name: "Mr. Daniel E. M. Lyatumba",
    position: "CEO",
    qualifications: "Founder & Visionary",
    bio: "Daniel E. M. Lyatumba is a Liquefied Petroleum Gas (LPG) expert who has overseen the growth of Tranquility Distributors from inception into one of Zambia's leading LPG enterprises. An accomplished Financial Specialist and Organisational Development practitioner, he integrates deep technical expertise in LPG sector development with strong capabilities in project finance, regulatory engagement, and institutional strengthening. Daniel is recognised for pragmatic problem‑solving, clear stakeholder communication, and an ability to build cross‑sector partnerships that accelerate infrastructure deployment and improve asset reliability. He has secured LPG project financing, led public–private collaborations, and contributed to sector‑wide reforms aimed at expanding safe and sustainable LPG adoption in Zambia. He serves as the General Secretary of the Zambia Liquefied Petroleum Gas Association (ZLPGA), where he plays a central role in sector advocacy, regulatory dialogue, and industry capacity development.",
    image: "/images/team/daniel-lyatumba.jpg",
  },
  {
    name: "Evans Lazarous Lyatumba",
    position: "Chief Operations Officer",
    qualifications: "BSc (Merit), MBA Candidate",
    bio: "Evans Lazarous Lyatumba is a key driver of Tranquility Distributors' growth, operational excellence, and market expansion. With more than seven years of hands‑on experience in Zambia's retail LPG sector, he brings a strong blend of commercial acumen, operational discipline, and people‑centered leadership to the organisation. Evans has played an instrumental role in supporting the company's fundraising and business development efforts, contributing to the capital mobilisation that has enabled Tranquility to scale its footprint and enter new markets. He has trained and mentored over 15 sales representatives, building a motivated, customer‑focused team that consistently delivers strong performance and embodies the company's service standards. He oversees day‑to‑day operations across all Tranquility facilities, ensuring uninterrupted stock availability, efficient resource utilisation, and smooth coordination of logistics and personnel. His work in strengthening relationships with key partners has helped reinforce Tranquility's reputation as a reliable, compliant, and growth‑oriented LPG enterprise. Evans holds a Bachelor's Degree (Merit) from the Copperbelt University and is currently pursuing an MBA in Finance at ZCAS University. He has further enhanced his business and leadership capabilities through professional development programmes with GrowthAfrica and Prospero. Evans remains committed to advancing Tranquility's mission of delivering safe, reliable LPG services to households and businesses nationwide.",
    image: "/images/team/evans-lyatumba.jpg",
  },
  {
    name: "Lucinda Mutale L. Chimfwembe",
    position: "Human Resource & Community Engagement Officer",
    qualifications: "Social Worker and Health Promotions Specialist",
    bio: "Lucinda Mutale L. Chimfwembe is a qualified Social Worker and Health Promotions Specialist with over 20 years of experience working with communities across Zambia. She oversees Tranquility's human resource function, ensuring that the organisation recruits skilled staff and places them in roles aligned with their qualifications and strengths. Lucinda plays a central role in building a motivated, high‑performing team. She ensures all staff receive the necessary training and consistently deliver services that meet the highest safety and operational standards. As Tranquility's primary link to the community, Lucinda leads LPG safety demonstrations for new clients and conducts ongoing education and advocacy campaigns. Her work promotes the adoption of clean‑cooking solutions, highlighting the health and environmental benefits of LPG while discouraging reliance on charcoal and firewood. Her commitment to community empowerment and safe energy practices strengthens trust, enhances awareness, and supports Zambia's transition to cleaner, healthier households.",
    image: "/images/team/lucinda-chimfwembe.jpg",
  },
  {
    name: "Ireen Mitti",
    position: "Sales Representative Supervisor",
    qualifications: "Sales Leadership & Team Development",
    bio: "Ireen Miti leads a vibrant, youthful sales team at Tranquility Distributors, most of whom are under 30 and predominantly female. She plays a key role in coordinating daily operations between sales representatives and the delivery team, ensuring efficiency and strong performance across all outlets. Passionate about people and results, Ireen works to grow sales volumes while maintaining the company's customer‑centric values; commitment to safety, reliability, and customer‑centric service. She is also a strong advocate for staff welfare, ensuring that the well‑being of both sales and support teams is prioritized. Her leadership fosters a supportive, energetic environment that drives both performance and team cohesion.",
    image: "/images/team/ireen-mitti.jpg",
  },
  {
    name: "Panji Ndhlovu",
    position: "Accountant",
    qualifications: "Finance & Compliance",
    bio: "Panji Ndhlovu is an experienced accounting professional with over five years of hands‑on experience in bookkeeping and financial administration. At Tranquility Distributors, he oversees the integrity and accuracy of the company's financial records across all sales facilities. He prepares the books of accounts, reconciles daily sales with bank deposits, and ensures that financial documentation is properly maintained, complete, and compliant with internal controls. Panji also manages statutory obligations, ensuring all filings and remittances are accurate and submitted on time. His strong grounding in accounting systems, attention to detail, and commitment to financial discipline support the organisation's operational efficiency and regulatory compliance.",
    image: "/images/team/panji-ndhlovu.jpg",
  },
  {
    name: "Jacob Simanwe",
    position: "Administrative Assistant",
    qualifications: "Administrative & Digital Content",
    bio: "Jacob Simanwe is the Administrative Assistant responsible for maintaining accurate staff, client, and partner records, and ensuring stock documentation across all sales facilities is properly reconciled. He oversees company equipment and vehicles, supports safety compliance at all facilities, and coordinates timely content materials for the website and social media platforms. Jacob brings over ten years of experience in content creation and photography, strengthening the organisation's digital presence.",
    image: "/images/team/jacob-simanwe.jpg",
  },
];

const partners = [
  {
    name: "AFROX Zambia",
    logo: "/images/partners/afrox.png",
    description:
      "Exclusive supplier of AFROX Handigas LPG. All our staff are AFROX‑certified, guaranteeing top‑quality gas and safety.",
    benefits: [
      "Premium Handigas LPG",
      "Joint safety training",
      "Continuous technical support",
      "Nationwide supply chain",
    ],
  },
  {
    name: "FNB Zambia",
    logo: "/images/partners/fnb.png",
    description:
      "Alliance partner providing flexible payment solutions. Our customers can pay via FNB mobile banking, card, or cash.",
    benefits: [
      "Easy mobile payments",
      "Corporate accounts",
      "Point‑of‑sale terminals",
      "Transactional security",
    ],
  },
  {
    name: "USAID",
    logo: "/images/partners/usaid.png",
    description:
      "Grant recipient for clean cooking expansion. Together we are bringing LPG to peri‑urban and rural communities around Lusaka.",
    benefits: [
      "Subsidised starter kits",
      "Community awareness campaigns",
      "Environmental impact reduction",
      "Sustainable energy access",
    ],
  },
  {
    name: "BETUZ",
    logo: "/images/partners/betuz.png",
    description:
      "Expanding access to clean cooking solutions for teachers nationwide. Deliver an affordable, safe and scalable LPG adoption programme.",
    benefits: [
      "Affordable price structure",
      "Safe adoption programme",
      "Scalable adoption programme",
      "Sustainable energy access",
    ],
  },
];

const About = () => {
  return (
    <div className="about">
      {/* Hero */}
      <section
        className="about-hero"
        style={{ backgroundImage: "url('/images/hero.jpg')" }}
      >
        <div className="about-hero-overlay" />
        <div className="container about-hero-content">
          <span className="hero-badge">Est. 2019</span>
          <h1>Zambia’s Trusted LPG Distributor</h1>
          <p className="about-hero-subtitle">
            Safe, reliable, and affordable Liquefied Petroleum Gas delivered to
            your door. 10 outlets across Lusaka, 1500+ happy clients monthly.
          </p>
        </div>
      </section>

      {/* Vision, Mission & Values */}
      <section className="vision-mission-section">
        <div className="container">
          <h2 className="section-title text-center">
            Our Vision, Mission & Values
          </h2>
          <p className="section-subtitle text-center">
            The principles that guide everything we do
          </p>

          <div className="vm-statement">
            <h3 className="vm-heading">Our Vision</h3>
            <p>
              A Zambia where every home and business enjoys safe, affordable,
              and reliable clean energy solutions.
            </p>
          </div>

          <div className="vm-statement">
            <h3 className="vm-heading">Our Mission</h3>
            <p>
              To deliver high‑quality LPG products through a compliant,
              efficient, and customer‑focused distribution network that expands
              access to clean cooking across communities.
            </p>
          </div>

          <div className="vm-statement">
            <h3 className="vm-heading">Our Values</h3>
            <ul className="values-list">
              <li>
                <strong>Safety</strong> — We uphold the highest safety and
                regulatory standards.
              </li>
              <li>
                <strong>Integrity</strong> — We operate with honesty,
                transparency, and accountability.
              </li>
              <li>
                <strong>Accountability</strong> — We take ownership of our
                actions, decisions, and commitments to customers, regulators,
                and partners.
              </li>
              <li>
                <strong>Reliability</strong> — We ensure consistent product
                availability and dependable service.
              </li>
              <li>
                <strong>Team Spirit</strong> — We work collaboratively, support
                one another, and celebrate shared success across all
                departments.
              </li>
              <li>
                <strong>Community</strong> — We support clean‑cooking adoption
                and local empowerment.
              </li>
              <li>
                <strong>Excellence</strong> — We continuously improve our
                operations and customer experience.
              </li>
            </ul>
          </div>
        </div>
      </section>

      {/* Company Overview */}
      <section className="section container">
        <h2 className="section-title">Company Overview</h2>
        <p>
          <strong>Tranquility Distributors</strong> was established in 2019 to
          distribute liquefied petroleum gas (LPG), gas stoves, and
          clean‑cooking accessories that promote the safe use of LPG. Based in
          Lusaka, we operate 10 distribution points: three at Zambia Air Force
          camps, five inside shopping malls, one at a meat shopping centre, and
          one at our office in the central business district.
        </p>
        <p>
          We are a leading LPG distributor for Afrox, the largest gases and
          welding‑products supplier in sub‑Saharan Africa and a member of the
          Linde Group. Afrox, founded in 1927 and listed on the JSE in 1963,
          supplies the products we distribute to both high‑ and low‑income
          communities, including Lusaka’s high‑density residential areas.
        </p>
        <p>
          Tranquility Distributors employs 27 people, 73% of whom are women and
          28% men. Most team members are under 30 and have completed secondary
          education; two hold university degrees (one BA in Business
          Administration and one LLB). All staff are trained and certified by
          Afrox to handle LPG products safely.
        </p>
        <p>
          In the most recent fiscal year (2025), the company generated USD
          700,000 in revenue and sold more than 265,000 kilograms of LPG.
        </p>

        <div className="key-milestones">
          <div className="milestone">
            <div className="milestone-number">
              <Counter end={1500} />+
            </div>
            <div className="milestone-text">Satisfied Clients Monthly</div>
          </div>
          <div className="milestone">
            <div className="milestone-number">
              <Counter end={10} />
            </div>
            <div className="milestone-text">Store Outlets</div>
          </div>
          <div className="milestone">
            <div className="milestone-number">
              <Counter end={6} />
            </div>
            <div className="milestone-text">Years Experience</div>
          </div>
        </div>

        <div className="cta-center">
          <Link to="/shop" className="btn-primary btn">
            Browse Products
          </Link>
        </div>
      </section>

      {/* Team */}
      <section className="section team-section">
        <div className="container">
          <h2 className="section-title">Our Management Team</h2>
          <p className="section-subtitle">
            Passionate people dedicated to delivering clean energy safely.
          </p>
          <div className="team-grid">
            {team.map((member, i) => (
              <div className="team-member-card" key={i}>
                <div className="member-image-container">
                  <img
                    src={member.image}
                    srcSet={`${member.image}?w=250 1x, ${member.image}?w=500 2x`}
                    alt={member.name}
                    className="member-image"
                  />
                </div>
                <div className="member-content">
                  <div className="member-header">
                    <h3 className="member-name">{member.name}</h3>
                    <div className="member-position">{member.position}</div>
                  </div>
                  <div className="member-qualifications">
                    {member.qualifications}
                  </div>
                  <div className="member-bio">
                    <p>{member.bio}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Partners */}
      <section className="section partners-section">
        <div className="container">
          <h2 className="section-title">Strategic Partnerships</h2>
          <p className="section-subtitle">
            Collaborations that drive our success and benefit you.
          </p>
          <div className="partners-grid">
            {partners.map((partner, idx) => (
              <div className="partner-card" key={idx}>
                <div className="partner-image">
                  <img
                    src={partner.logo}
                    alt={partner.name}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.src = "/images/partners/placeholder.png";
                    }}
                  />
                </div>
                <div className="partner-content">
                  <h3>{partner.name}</h3>
                  <p className="partner-description">{partner.description}</p>
                  <div className="partner-benefits">
                    <h4>Key Benefits</h4>
                    <ul>
                      {partner.benefits.map((b, i) => (
                        <li key={i}>{b}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="contact-cta-section">
        <div className="container contact-cta-content">
          <h2 className="cta-title">Ready to Switch to Clean Energy?</h2>
          <p className="cta-subtitle">
            Visit any of our 10 outlets or contact us for a free consultation.
          </p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn-primary btn">
              Contact Us
            </Link>{" "}
            <Link to="/shop" className="btn-outline btn">
              View Products
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
